
import './header.scss';
import { Link } from 'react-router-dom';

import { useState } from 'react';
import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';

import translationEn from './../../public/lang/translationEn.json';
import translationRu from './../../public/lang/translationRu.json';
import translationLv from './../../public/lang/translationLv.json';

i18n.use(initReactI18next).init({
    resources: {
        en: {translation: translationEn},
        ru: {translation: translationRu},
        lv: {translation: translationLv}
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {escapeValue: false}
})

const Header = (props) => {

    const [menuAnimation, setMenuAnimation ] = useState(false);

    const { t } = useTranslation();

    const languageSwitcher = (event) => {
        i18n.changeLanguage(event.target.value)
    }

    const menuHandler = () => {
        setMenuAnimation(false);
    }

    const menuHandlerButton = () => {
        setMenuAnimation(prev => !prev);
    }

    return (
        <div className="header_menu">
            <div className="Header">
                <div className="logo_section">
                    <div className="logo_image"></div>
                </div>
                <ul className="menu_list">
                    <li className="menu_item">
                        <Link className='link_cast' to="/">
                            <p className="text">{t('Header.link_label_home')}</p>
                            <hr/>
                        </Link>
                    </li>
                    <li className="menu_item">
                        <Link className='link_cast' to="service">
                            <p className="text">{t('Header.link_label_service')}</p>
                            <hr/>
                        </Link>
                    </li>
                    <li className="menu_item">
                        <Link className='link_cast' to="ourclients">
                            <p className="text">{t('Header.link_label_clients')}</p>
                            <hr/>
                        </Link>
                    </li>
                    <li className="menu_item">
                        <Link className='link_cast' to="about">
                            <p className="text">{t('Header.link_label_about')}</p>
                            <hr/>
                        </Link>
                    </li>
                    <li className="menu_item">
                        <Link className='link_cast' to="promo">
                            <p className="text">{t('Header.link_label_promo')}</p>
                            <hr/>
                        </Link>
                    </li>
                </ul>
                <div className="bottom_actions">
                    <div className="lang_switcher">
                        <select name="langauge" onChange={languageSwitcher}>
                            <option value="en">English</option>
                            {/* <option value="ru">Russian</option> */}
                            <option value="lv">Latvian</option>
                        </select>
                    </div>
                    <div className="contact_section">
                        <Link className='link_cast contact_button' to="./contact">
                            <p className="text">{t('Header.link_label_contact')}</p>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="Header_mobile_top_bar">
                <div className={menuAnimation ? 'button_open_menu close' : 'button_open_menu'} onClick={menuHandlerButton} aria-label={menuAnimation ? 'Close menu' : 'Open menu'} aria-expanded={menuAnimation}>
                    <hr />
                    <hr className='middle'/>
                    <hr />
                </div>
                <div className="mobile_lang_switcher">
                    <select name="langauge" onChange={languageSwitcher}>
                        <option value="en">English</option>
                        {/* <option value="ru">Russian</option> */}
                        <option value="lv">Latvian</option>
                    </select>
                </div>
            </div>
            <div className={`wrapper ${menuAnimation ? 'open' : ''}`} onClick={menuHandler}>
                <div className={menuAnimation ? 'Header_mobile_side' : 'Header_mobile_side disactive'} onClick={(e) => e.stopPropagation()}>
                    <ul className="menu_list">
                        <li className="menu_item">
                            <Link className='menu_link' to="/" onClick={menuHandler}>
                                <p className="text">{t('Header.link_label_home')}</p>
                            </Link>
                        </li>
                        <li className="menu_item">
                            <Link className='menu_link' to="service" onClick={menuHandler}>
                                <p className="text">{t('Header.link_label_service')}</p>
                            </Link>
                        </li>
                        <li className="menu_item">
                            <Link className='menu_link' to="ourclients" onClick={menuHandler}>
                                <p className="text">{t('Header.link_label_clients')}</p>
                            </Link>
                        </li>
                        <li className="menu_item">
                            <Link className='menu_link' to="about" onClick={menuHandler}>
                                <p className="text">{t('Header.link_label_about')}</p>
                            </Link>
                        </li>
                        <li className="menu_item">
                            <Link className='menu_link' to="promo" onClick={menuHandler}>
                                <p className="text">{t('Header.link_label_promo')}</p>
                            </Link>
                        </li>
                        <li className="menu_item">
                            <Link className='menu_link' to="/contact" onClick={menuHandler}>
                                <p className="text">{t('Header.link_label_contact')}</p>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        )
    
}

export default Header;